import React from 'react';
const GlobalSearchSvg = () => React.createElement("span", { className: "sirius-icon sirius-icon-globalSearch" });
GlobalSearchSvg.Enhance = () => React.createElement("span", { className: "sirius-icon sirius-icon-globalSearch sirius-icon-globalSearch-enhance" });
export default GlobalSearchSvg;
